import BaseParameterAction from './BaseParameterAction.js';

class SnapAutomationBreakPoint extends BaseParameterAction {
    execute({automation, point}) {
        let savedPoint = point.getJson ? point.getJson() : point;
        automation.quantizePoint(point);
        return {
            savedPoint
        };
    }

    undo({payload}) {
        payload.automation.movePoint(
            payload.point,
            payload.savedPoint.step,
            payload.savedPoint.value);
    }
}

export default SnapAutomationBreakPoint;
